export default "__VITE_ASSET__abd47bfd__"